import { useMemo } from "react";
import { UNSAFE_LocationContext, useNavigationType } from "react-router-dom";

export const StableLocationProvider = ({ location, children }) => {
  const navigationType = useNavigationType();
  const value = useMemo(() => ({ location, navigationType }), [location.key]);
  return <UNSAFE_LocationContext.Provider value={value}>{children}</UNSAFE_LocationContext.Provider>;
};
